// This custom hook is used to detect input field changes by the user
// On calling the handleFieldChange auto save gets triggered - only for recalculate/Draft HSA flow

import { useState, useCallback } from 'react';
import { isRecalculatingHSAAtom } from 'atoms/isRecalculatingHSA';

type FieldChangeTracker = [number, () => void];

const useFieldChangeTracker = (): FieldChangeTracker => {
  const [changeCount, setChangeCount] = useState(0);

  const handleFieldChange = useCallback(() => {
    if (!isRecalculatingHSAAtom) return;
    setChangeCount((count) => count + 1);
  }, []);

  return [changeCount, handleFieldChange];
};

export default useFieldChangeTracker;
